import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiHeadphones,FiZap,FiCreditCard,FiGlobe,FiFileText,FiX,FiMessageSquare,FiCheck}=FiIcons;

const PackageSection=()=> {
const packageItems=[ 
{icon: FiHeadphones,title: "Atención directa al comensal",description: "Ticket Factura atiende directamente a tus clientes para resolver cualquier duda sobre la facturación."},
{icon: FiZap,title: "Auto-facturación inmediata con QR",description: "El comensal puede facturar en segundos desde su ticket,sin esperas de minutos,horas ni días."},
{icon: FiCreditCard,title: "Facturación en caja",description: "Genera la factura directamente desde caja en cuestión de segundos."},
{icon: FiGlobe,title: "Factura global a público general",description: "Simplifica la administración con la emisión de facturas globales."},
{icon: FiFileText,title: "Notas de crédito y facturas PPD",description: "Administra correctamente las operaciones de crédito y devoluciones."},
{icon: FiX,title: "Cancelaciones",description: "Gestión rápida y sencilla de cancelaciones de facturas."},
{icon: FiMessageSquare,title: "Encuestas de satisfacción",description: "Cada cliente que pide factura puede dejar su opinión sobre el servicio."} 
];

const benefits=[ 
"Clientes atendidos al instante=clientes felices y más ventas",
"Conocer la opinión real de tus clientes",
"Reportes de facturación listos para conciliación con tu sistema",
"Implementación rápida,sin importar el punto de venta que uses",
"Disminución de quejas y reclamos relacionados con facturación" 
];

// WhatsApp message text encoded for URL 
const whatsappMessage=encodeURIComponent("Me interesa conocer la oferta de valor");
const whatsappLink=`https://wa.me/5214775954969?text=${whatsappMessage}`;

return ( 
<section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white"> 
<div className="container mx-auto px-4"> 
<motion.div className="text-center mb-16" initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} > 
<h2 className="text-4xl md:text-5xl font-bold mb-6"> Paquete Completo de <span className="text-gradient bg-gradient-to-r from-yellow-400 to-orange-400 bg-clip-text text-transparent">Facturación Inteligente</span> </h2> 
<p className="text-xl opacity-90 max-w-3xl mx-auto"> Todo lo que necesitas para transformar la facturación de tu restaurante </p> 
</motion.div> 
<div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto"> 
{/* Package Items */} 
<div> 
<h3 className="text-2xl font-bold mb-8 text-yellow-400">Lo que incluye:</h3> 
<div className="space-y-6"> 
{packageItems.map((item,index)=> ( 
<motion.div key={index} className="bg-white bg-opacity-5 backdrop-blur-sm rounded-lg p-6 border border-gray-700" initial={{opacity: 0,x: -50}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.6,delay: index * 0.1}} viewport={{once: true}} > 
<div className="flex items-start gap-4"> 
<div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-full p-3"> 
<SafeIcon icon={item.icon} className="text-xl" /> 
</div> 
<div className="flex-1"> 
<h4 className="text-lg font-bold mb-2">{item.title}</h4> 
<p className="text-gray-300">{item.description}</p> 
</div> 
</div> 
</motion.div> 
))} 
</div> 
<motion.div className="mt-8 bg-gradient-to-r from-red-600 to-orange-600 rounded-lg p-6" initial={{opacity: 0,scale: 0.9}} whileInView={{opacity: 1,scale: 1}} transition={{duration: 0.8}} viewport={{once: true}} > 
<div className="text-center"> 
<p className="text-2xl font-bold text-yellow-400 mt-2">Tenemos una oferta de valor increíble para empresas decididas e interesadas</p> 
{/* Value Offer Image with WhatsApp Link */} 
<motion.div className="my-4 flex justify-center" initial={{opacity: 0,y: 20}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.6,delay: 0.2}} viewport={{once: true}} > 
<a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-block cursor-pointer transform transition-transform duration-300 hover:scale-105" > 
<img src="https://www.ticketfactura.com/wp-content/uploads/2025/09/claudia-automatiza-restaurante-ticket-fatura.jpg" alt="Claudia automatiza restaurante con Ticket Factura - Haz clic para contactar por WhatsApp" className="max-w-full rounded-lg shadow-lg" /> 
</a> 
</motion.div> 
</div> 
</motion.div> 
</div> 
{/* Benefits */} 
<div> 
<h3 className="text-2xl font-bold mb-8 text-yellow-400">Beneficios que obtienes:</h3> 
<div className="space-y-4"> 
{benefits.map((benefit,index)=> ( 
<motion.div key={index} className="flex items-start gap-3" initial={{opacity: 0,x: 50}} whileInView={{opacity: 1,x: 0}} transition={{duration: 0.6,delay: index * 0.1}} viewport={{once: true}} > 
<SafeIcon icon={FiCheck} className="text-green-400 text-xl mt-1 flex-shrink-0" /> 
<p className="text-gray-300">✅ {benefit}</p> 
</motion.div> 
))} 
</div> 
<motion.div className="mt-8 bg-gradient-to-br from-yellow-400 to-orange-400 text-gray-900 rounded-lg p-6" initial={{opacity: 0,y: 50}} whileInView={{opacity: 1,y: 0}} transition={{duration: 0.8}} viewport={{once: true}} > 
<h4 className="text-xl font-bold mb-3">🚀 Resultado Garantizado:</h4> 
<p className="text-lg"> Desde el primer mes verás una disminución en quejas por facturación,clientes más satisfechos y procesos más rápidos y eficientes en tu restaurante. </p> 
</motion.div> 
</div> 
</div> 
</div> 
</section> 
);};
export default PackageSection;